import { Link, useLocation } from "react-router-dom";
import { ArrowUp } from "lucide-react";
import { LogoMark } from "@/components/Logo";

export default function Footer() {
  const location = useLocation();
  const onHome = location.pathname === "/";
  return (
    <footer className="border-t border-white/[0.07] bg-[#0B0F17]">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <div className="flex flex-col sm:flex-row items-start sm:items-center justify-between gap-8">
          <div className="flex items-center gap-3">
            <LogoMark size={32} />
            <div className="leading-tight">
              <p className="font-display font-bold tracking-[0.12em] text-white text-sm">ROBERT DANIELS</p>
              <p className="font-mono text-[10px] uppercase tracking-[0.26em] text-[#6B7280]">
                MRP · Inventory Control · Poway, CA
              </p>
            </div>
          </div>
          <nav className="flex flex-wrap gap-x-7 gap-y-3">
            {[
              ["/services", "Services"],
              ["#value", "The Problem"],
              ["#resume", "Experience"],
              ["#capabilities", "Capabilities"],
              ["#contact", "Contact"],
            ].map(([href, label]) =>
              href === "/services" ? (
                <Link
                  key={href}
                  to={href}
                  data-testid={`footer-link-${label.toLowerCase().replace(/\s+/g, "-")}`}
                  className="font-mono text-[11px] uppercase tracking-[0.2em] text-[#9CA3AF] hover:text-[#00F0FF] transition-colors"
                >
                  {label}
                </Link>
              ) : (
                <a
                  key={href}
                  href={onHome ? href : `/${href}`}
                  data-testid={`footer-link-${label.toLowerCase().replace(/\s+/g, "-")}`}
                  className="font-mono text-[11px] uppercase tracking-[0.2em] text-[#9CA3AF] hover:text-[#00F0FF] transition-colors"
                >
                  {label}
                </a>
              )
            )}
          </nav>
          <a
            href="#top"
            data-testid="footer-back-to-top"
            aria-label="Back to top"
            className="h-11 w-11 shrink-0 rounded-full border border-white/10 bg-white/[0.04] text-[#9CA3AF] hover:text-[#00F0FF] hover:border-[#00F0FF]/50 flex items-center justify-center transition-all duration-300"
          >
            <ArrowUp size={17} />
          </a>
        </div>
        <div className="mt-10 pt-7 border-t border-white/[0.06] flex flex-col sm:flex-row justify-between gap-3">
          <p className="font-mono text-[10px] uppercase tracking-[0.18em] text-[#6B7280]">
            © 2026 Robert Daniels · Inventory Control &amp; MRP Specialist
          </p>
          <p className="font-mono text-[10px] uppercase tracking-[0.18em] text-[#6B7280]">
            robdan316@gmail.com · (858) 231-7380
          </p>
        </div>
      </div>
    </footer>
  );
}
